import { keepPreviousData } from "@tanstack/react-query";
import { useCallback } from "react";
import { useNavigate } from "react-router";

import { DashboardFigure } from "@components/Dashboards/shell";

import { routes } from "@pages/routes";

import { useClientEmployeeOwnedApplicationsCountQuery } from "./EmployeeOwnedAppsCountStat.g";

type Props = {
  clientEmployeeId: string;
  clientId: string;
  prominent?: boolean;
};

export const EmployeeOwnedAppsCountStat = ({
  clientEmployeeId,
  clientId,
  prominent,
}: Props) => {
  const navigate = useNavigate();

  const { data, isLoading } = useClientEmployeeOwnedApplicationsCountQuery(
    {
      clientId,
      businessOwnerId: clientEmployeeId,
    },
    {
      placeholderData: keepPreviousData,
    },
  );

  const ownedAppCount = data?.clientApplications?.totalCount ?? 0;

  const handleOpenOwnedApplications = useCallback(() => {
    navigate(
      routes.portal.clients.client.clientEmployees.clientEmployee.ownedApplications.$buildPath(
        {
          params: { clientId, clientEmployeeId },
        },
      ),
    );
  }, [clientEmployeeId, clientId, navigate]);

  return (
    <DashboardFigure
      prominent={prominent}
      label="Owned applications"
      value={ownedAppCount.toString()}
      detail="All time"
      isLoading={isLoading}
      onClick={handleOpenOwnedApplications}
    />
  );
};
